
    import '/mnt/src/components/Popup/index.md?watch=parent';
    export const demoIndex = {
  ids: ["popup-demo-comprehensivedemo"],
  getter: () => import(/* webpackChunkName: "meta__components" */'/mnt/src/components/Popup/index.md?type=demo')
};